import React from 'react';
import { Modal } from 'react-bootstrap';
import cx from './cx';

function ModalShell({
  show,
  onHide,
  title,
  children,
  footer,
  size,
  centered = true,
  className,
  backdropClassName,
  bodyClassName,
  headerClassName,
  footerClassName,
  titleClassName,
  ...props
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      size={size}
      centered={centered}
      dialogClassName={cx('rg-modal', className)}
      backdropClassName={cx('rg-modal-backdrop', backdropClassName)}
      {...props}
    >
      {title ? (
        <Modal.Header closeButton className={headerClassName}>
          <Modal.Title className={titleClassName}>{title}</Modal.Title>
        </Modal.Header>
      ) : null}
      <Modal.Body className={bodyClassName}>{children}</Modal.Body>
      {footer ? <Modal.Footer className={footerClassName}>{footer}</Modal.Footer> : null}
    </Modal>
  );
}

export default ModalShell;
